import { z } from 'zod';
/** M4-01: channel, then outcome — two clicks. Everything else is pre-filled or optional. */
export const logTouchSchema = z.object({
    contactId: z.uuid(),
    /** the opportunity this touch moves; defaults to the contact's open opportunity */
    opportunityId: z.uuid().nullish(),
    /** reference-list keys */
    channel: z.string().min(1).max(60),
    outcome: z.string().min(1).max(60),
    /** pre-filled from the ICP's approved pitch (M4-01); can be changed */
    pitchId: z.uuid().nullish(),
    occurredAt: z.iso.datetime({ offset: true }).nullish(),
    /** M4-07: up to 280 characters, no personal data */
    note: z.string().trim().max(280).nullish(),
    nextActionAt: z.iso.date().nullish(),
    nextActionNote: z.string().trim().max(280).nullish(),
    /** for "Not now": when to re-engage (defaults to 90 days) */
    reengageAt: z.iso.date().nullish(),
    /** the contact asked not to be contacted again (M4-06) */
    optOut: z.boolean().default(false),
});
//# sourceMappingURL=touches.js.map